<template>
  <login-layout>
    <div class="text-center">

      <div v-if="processing">
        <h3>Your response is being recorded</h3>
        <p>Please wait...</p>
      </div>

      <div v-if="!processing && success" >
        <h3>Thank You!</h3>
        <p>Successfully recorded your response</p>
        <div class="flex w-full justify-center">
          <a href="/" class="btn btn-dark">
            Continue to Dashboard
          </a>
        </div>
      </div>

      <div v-if="!processing && !success" >
        <h3>Unable To Record Response</h3>

        <p>
          {{ this.message }}
        </p>

        <div class="flex w-full justify-center">
          <a href="/" class="btn btn-dark">
            Continue to Dashboard
          </a>
        </div>
      </div>

    </div>
  </login-layout>
</template>

<script>
import LoginLayout from './auth/LoginLayout'

export default {
  components: {
    LoginLayout
  },

  props: {
    responseId: {
      type: String
    },
    userId: {
      type: String
    },
    token: {
      type: String
    }
  },

  data () {
    return {
      processing: true,
      success: false,
      error: null,
      message: ''
    }
  },

  mounted () {
    this.$http.put(`respond/${this.responseId}/${this.userId}/${this.token}`).then(response => {
      this.processing = false
      this.success = response.data.success
      this.message = response.data.message
    }).catch(error => {
      this.processing = false
      this.error = error.response
    })
  }

}
</script>
